import {
  useGlobalConfirmModalActions,
  useGlobalConfirmModalState,
} from '@shared/redux/ducks/global-confirm-modal';
import { ConfirmModal } from '@shared/ui/confirm-modal';
import { type FC, useState } from 'react';

export const GlobalConfirmModal: FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { closeConfirmModal } = useGlobalConfirmModalActions();
  const { isOpen, title, text, cancelButtonLabel, confirmButtonLabel, onConfirm, onClose } =
    useGlobalConfirmModalState();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    closeConfirmModal();
  };

  const handleConfirm = async () => {
    const promise = onConfirm();

    if (typeof promise === 'undefined') {
      closeConfirmModal();
      return;
    }

    try {
      setIsLoading(true);
      await promise;

      handleClose();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={title}
      text={text}
      confirmButtonLabel={confirmButtonLabel}
      cancelButtonLabel={cancelButtonLabel}
      onConfirm={handleConfirm}
      onCancelButton={handleClose}
      onClose={closeConfirmModal}
      isLoading={isLoading}
    />
  );
};
